export type PersonalizationConfig = {
  projectCode?: string;
} & { [key: string]: any };

export type PlayerSetupConfig = {
  videoCode: string;

  /**
   * Player configuration. If video code is present, it will be used to override configuration
   * fetched from server.
   */
  configuration: any;
  personalizationConfig?: PersonalizationConfig;
};

const validateConfig = (config: PlayerSetupConfig): void => {
  const projectCode = config.personalizationConfig.projectCode;

  const hasScenarioElements = !!config.configuration?.se;

  if (projectCode && config.videoCode) {
    throw new Error("Cannot use video code and project code at the same time.");
  }

  if (!config.videoCode && !hasScenarioElements && !projectCode) {
    throw new Error("Either video code or projectCode must be provided.");
  }
};

export const createPlayerSetupConfig = (
  videoCode?: string,
  configuration?: any,
  personalizationConfig?: PersonalizationConfig,
): PlayerSetupConfig => {
  const config = {
    videoCode,
    configuration,
    personalizationConfig: personalizationConfig || {},
  };

  validateConfig(config);

  return config;
};
